import { atom } from 'jotai';

import {
  Company,
  CounterpartyQueryFilters,
  InvoiceQueryFilters,
  InvoiceSortColumns,
  InvoiceStages,
  PaymentStatus,
  SortOrder,
  User,
  EntryType
} from 'openapi';

import { INITIAL_PAGINATION_PROPS } from 'utils/constants/paginations';
import { CounterpartyFilterType } from 'utils/enums/Counterparty';
import { FilterType } from 'utils/enums/FilterType';

export const invoicesPaginationAtom = atom<{
  page: number;
  pageSize: number;
}>({
  page: INITIAL_PAGINATION_PROPS.page,
  pageSize: INITIAL_PAGINATION_PROPS.pageSize
});

export const userAtom = atom<User | null>(null);
export const companyAtom = atom<Company>();
export const filterTypeAtom = atom<FilterType | CounterpartyFilterType | null>(
  null
);
export const isRequestPendingAtom = atom<boolean>(false);

const BASE_FILTERS = {
  sortOrder: SortOrder.DESC,
  amount: {},
  invoiceDate: {},
  uploadedDate: {}
};

export const invoicesFiltersAtom = atom<InvoiceQueryFilters>({
  ...BASE_FILTERS,
  sortBy: InvoiceSortColumns.INSERTED_AT,
  entryType: EntryType.EXPENSE
});

export const invoicesFiltersAtomForApproval = atom<InvoiceQueryFilters>({
  ...BASE_FILTERS,
  sortBy: InvoiceSortColumns.COMPANY_PAYMENT_REIMBURSEMENT_EXPENSE,
  stages: [InvoiceStages.VALIDATED],
  isForApproval: true,
  entryType: EntryType.EXPENSE
});

export const invoicesFiltersAtomForAccounting = atom<InvoiceQueryFilters>({
  ...BASE_FILTERS,
  sortBy: InvoiceSortColumns.COMPANY_PAYMENT_REIMBURSEMENT_EXPENSE,
  isBooked: false,
  stages: [InvoiceStages.APPROVED],
  entryType: EntryType.EXPENSE
});

export const invoicesFiltersAtomForPayment = atom<InvoiceQueryFilters>({
  ...BASE_FILTERS,
  sortBy: InvoiceSortColumns.COMPANY_PAYMENT_REIMBURSEMENT_EXPENSE,
  stages: [InvoiceStages.APPROVED],
  paymentStatuses: [PaymentStatus.NOT_PAID, PaymentStatus.OPEN_BANKING_FAILED],
  entryType: EntryType.EXPENSE
});

export const revenueFiltersAtom = atom<InvoiceQueryFilters>({
  ...BASE_FILTERS,
  sortBy: InvoiceSortColumns.INSERTED_AT,
  entryType: EntryType.REVENUE
});

export const areFiltrsVisibleAtom = atom<boolean>(false);
export const selectedCompanyIdAtom = atom<number>();
export const isExportButtonDisabledAtom = atom<boolean>(false);
export const exportButtonTooltipTextAtom = atom<string>('');

export interface CounterpartiesGridState {
  filters: CounterpartyQueryFilters;
  paginationModel: { page: number; pageSize: number };
}

export const counterpartiesGridStateAtom = atom<
  Record<string, CounterpartiesGridState>
>({});
